import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { colors } from "utils";

// Pencil that opens the Rename Class modal, shown beside the class dropdown in
// the differentiation and im360 dashboard headers. Mirrors the legacy
// ClassroomFilter pencil so the affordance looks the same everywhere.
export const EditClassButton = ({ onClick }) => (
  <button
    type="button"
    onClick={onClick}
    title="Rename class"
    aria-label="Rename class"
    style={{
      alignItems: "center",
      backgroundColor: "transparent",
      border: "none",
      color: colors.nightlyWoods500,
      cursor: "pointer",
      display: "flex",
      padding: "8px",
    }}
  >
    <FontAwesomeIcon icon={faPencilAlt} style={{ fontSize: "16px" }} />
  </button>
);
